export const refresh = () => {
  Helpers.update();
}

export const toggleMenu = () => {
  Helpers.toggleCollapsed();
}